export default __webpack_public_path__ + "static/media/Image-8.2b0c0640.jpg";